<template>
    <v-dialog 
      v-model="localOpen"
      max-width="500"
    >
      <s-card class="grey darken-3">
        <span class=" d-block headline white--text mt-4 " :class="[$vuetify.breakpoint.mdAndUp ? 'mb-0 px-3 ' : 'px-5 mb-2']">
          {{ title }}
        </span>
        <v-card-text class="">
            <v-row>

            <v-col cols="12" sm="6" v-for="(item, i) in options" :key="i">
                <v-list-item-title v-if="item.type != 'date'" v-html="item.label"></v-list-item-title>
          





                     
                <v-text-field dark
                  v-if="item.type == 'text' || item.type == 'number'" 
                  :type="item.type" 
                  
                  v-model="localValues[i]"
                  name=""
                  ref=""
                  type="text"
                  class="my-0"
                  placeholder="Geen invoer"

                ></v-text-field>
                      



                <v-select v-if="item.type == 'select'" v-model="localValues[i]" :items="item.options" placeholder="maak een keuze"></v-select>
                <v-select v-if="item.type == 'multiselect'" v-model="localValues[i]" :items="item.options" v-bind:multiple="true"></v-select>
                <v-menu>
                  <template v-if="item.type == 'date'" v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="localValues[i]"
                      :label="item.label"
                      prepend-icon="event"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable 
                    ></v-text-field>
                  </template>
                  <v-date-picker v-if="item.type == 'date'" no-title v-model="localValues[i]" locale="nl" :first-day-of-week="1"></v-date-picker>
                </v-menu>


            </v-col>




          </v-row>
        </v-card-text>
        <v-card-actions class="grey darken-2">
            <v-spacer></v-spacer>
            <v-btn class="text-none" color="primary" @click="localOpen = false">Annuleren</v-btn>
            <v-btn class="text-none" color="primary" @click="filter">Filteren</v-btn>
        </v-card-actions>
      </s-card>
    </v-dialog>
</template>
<script>
export default {
    props:['title', 'options', 'open', 'values'],
  data() {
      return {
          localValues: {}

      };
  },
  computed:
  {
    localOpen:
    {
        get: function(){ return this.open },
        set: function(value){ this.$emit('update:open', value) }
    }
  },
  watch:
  {
    values: {
      deep:true,
          handler (newState, old) {
           this.setValues();
      }
    },
    open:{
        handler(newState, old) {
            if(newState)
            {
                this.setValues();
            }
        }
    }
  },
  mounted: function()
  {
      this.setValues();
  },
  methods:
  {
    filter: function()
    {
        this.$emit('filter', this.localValues);
        this.localOpen = false;
    },
    setValues: function()
    {
      this.localValues = JSON.parse(JSON.stringify(this.values));
    }
  }
};
</script>